import React from 'react';
import EmptyDropPlaceholder from '../../placeholder';
import {sectionsEditable} from "../../constants";

const SectionListEditable = ({
    pageSections,
    pageId,
    siteId,
    faqsTypes,
    showDeleteSectionDialog,
    showEnableSectionDialog,
    showDisableSectionDialog,
    hideActions
}) => {
    return (
        <div>
            <EmptyDropPlaceholder index={-1} />
            {pageSections.map((section, i) => {
                const SectionEditable = sectionsEditable[section.type_id];
                return (
                    <div key={i}>
                        <SectionEditable
                            hideDragIcon={true}
                            blockId={section.block ? section.block.id : null}
                            blockType={section.block ? 'Text Block' : null}
                            blockTypeId={section.block ? section.block.block_type_id : null}
                            block={section.block}
                            data={section.data ? section.data : []}
                            deletable={section.deletable}
                            visible={section.is_visible}
                            sectionType={section.section_type}
                            sectionTypeId={section.type_id}
                            index={i}
                            id={section.uniqueId}
                            pageId={pageId}
                            siteId={siteId}
                            faqsTypes={faqsTypes}
                            new={section.new}
                            touched={section.touched}
                            title={section.data !== undefined && section.data.title !== undefined ? section.data.title : ''}
                            body={section.data !== undefined && section.data.body !== undefined ? section.data.body : ''}
                            section={section}
                            instructions={section.data !== undefined && section.data.instructions !== undefined ? section.data.instructions : ''}
                            deleteSection={showDeleteSectionDialog}
                            enableSection={showEnableSectionDialog}
                            disableSection={showDisableSectionDialog}
                            hideActions={hideActions}
                        />
                        <EmptyDropPlaceholder index={i} />
                    </div>
                )
            })}
        </div>
    )
};

export default SectionListEditable;




// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/section_list.js